import * as React from 'react';

import * as styles from './CardActionsGroup.css';

export interface ICardActionsGroupProps {
  compare?: React.ReactNode;
  favorite?: React.ReactNode;
  share?: React.ReactNode;
}

/**
 * Группа иконочных кнопок поверх фото карточки ЖК.
 * Лежит внутри ссылки на карточку, поэтому каждая вложенная кнопка обязана гасить событие сама.
 */
export const CardActionsGroup: React.FC<ICardActionsGroupProps> = ({ compare, favorite, share }) => {
  return (
    <div className={styles['container']} data-name="CardActionsGroup" data-testid="CardActionsGroup">
      {compare}
      {favorite}
      {share}
    </div>
  );
};
